import { requestChangeStatusTeamRegister } from 'app/api/event'
import { RegisterTeamActivityStatus } from 'app/api/event/model'
import { BaseButton } from 'app/components/common/BaseButton'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import {
  BaseModalComponent,
  IRefModal,
} from 'app/components/common/ModalComponent'
import { ILocation } from 'app/containers/EventManagement/layouts/CreateEvent/type'
import { notificationController } from 'app/controllers/notification-controller'
import { EventKeys } from 'app/react-query/query-key/event'
import { useAppSelector } from 'app/redux/hooks'
import { useRef, useState } from 'react'
import { useQueryClient } from 'react-query'

export const ModalApproveTeam = ({
  id,
  locations,
}: {
  id?: number
  locations?: ILocation[]
}) => {
  const user = useAppSelector(state => state?.user)?.profile
  const refModal = useRef<IRefModal>({})

  const [form] = BaseForm.useForm<{ reason?: string }>()

  const query = useQueryClient()
  const [isLoadingApprove, setIsLoadingApprove] = useState(false)

  const onPressApprove = async (
    id?: number,
    statusOther?: RegisterTeamActivityStatus,
  ) => {
    if (!id || !statusOther || !user?.member?.id) return
    try {
      setIsLoadingApprove(true)

      const res = await requestChangeStatusTeamRegister({
        id,
        status: statusOther,
        approvedById: +user?.member?.id,
        locationIds: locations?.map(itm => `${itm?.id ?? 0}`),
      })
      if (res) {
        query.invalidateQueries({
          queryKey: EventKeys.allListActionNotJoinByTeam,
        })
        query.invalidateQueries({
          queryKey: EventKeys.allListActionRegisteredByTeam,
        })

        notificationController?.success({ message: 'Đã phê duyệt!' })
        refModal?.current?.hide?.()
      }
    } catch (error) {
      console.log({ error })
    } finally {
      setIsLoadingApprove(false)
    }
  }

  const handleSubmit = async () => {
    if (!id) return
    await onPressApprove(id, RegisterTeamActivityStatus.ACCEPTED)
  }

  return (
    <BaseModalComponent
      ref={refModal}
      titleModal="Phê duyệt đăng ký"
      buttonOpenModal={
        <BaseButton
          children="Phê duyệt"
          onClick={() => refModal.current?.open?.()}
          type="text"
        />
      }
      handleSubmit={form?.submit}
      isLoadingConfirm={isLoadingApprove}
      renderContent={
        <BaseForm form={form} onFinish={handleSubmit}>
          <BaseSpace size={8}>
            <BaseText
              children={`Bạn có chắc chắn phê duyệt đơn đăng ký này?`}
              fontWeight="medium"
              fontSize="xs"
            />
            <BaseText
              children={`Lưu ý: Sau khi phê duyệt, bạn có thể thay đổi trạng thái của đoàn viên trong hoạt động`}
              colorText="statesOrangeColor"
              opacity="0.8"
            />
          </BaseSpace>
        </BaseForm>
      }
    />
  )
}
